import React from "react";
import { v4 } from "uuid";

const fieldType = [
  "TextField",
  "TextArea",
  "Dropdown",
  "Radio",
  "Checkbox",
  "Date",
  "Number",
  "Currency"
];

const FieldType = (props) => {
  return (
    <div className="pr-8 field-type row d-flex flex-column">
      <label>Field Type</label>
      <select onChange={props.changeFieldHandler}>
        {fieldType.map((type) => {
          return (
            <option
              key={v4()}
              value={type}
              disabled={props.inputType === type ? true : false}
              selected={props.inputType === type ? true : false}
            >
              {type}
            </option>
          );
        })}
      </select>
    </div>
  );
};

export default FieldType;
